// assumes string is lowercase
module.exports=function(s){
	return s.charAt(0).toUpperCase()+s.slice(1)
}
